const customATCButtinInit = () => {
  const allButtons = document.querySelectorAll("button.custom-atc-button,.custom-variant-hover-display button.button");
  if(allButtons.length > 0){
     const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
     const isOldCart = document.querySelector('#cart-drawer'); // Old cart drawer element
     
    allButtons.forEach((button) => {
      button.addEventListener("click",(evt) => {
        evt.preventDefault();
        const mainId = button.dataset.vid;
        
        let items = [
            {
              id:mainId,
              quantity:1,
            }
        ];
        
        // If using old cart, dispatch custom event instead
        if (isOldCart && !cart) {
          button.classList.add('loading');
          const spinner = button.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
          
          document.dispatchEvent(new CustomEvent('cart:add', {
            detail: {
              data: {
                items: items
              },
              button: button // Pass button reference to remove loading state later
            }
          }));
          return;
        }
        
        const formData = {
          items:items,
          sections:cart.getSectionsToRender().map((section) => section.id),
          sections_url:window.location.pathname
        };
        button.classList.add('loading');
        button.querySelector('.loading__spinner').classList.remove('hidden');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
          }
          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: mainId,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });      
          CartPerformance.measure("add:paint-updated-sections", () => {
            cart.renderContents(response);
          });
              
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          button.classList.remove('loading');
          button.querySelector('.loading__spinner').classList.add('hidden');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          CartPerformance.measureFromEvent("add:user-action", evt);
        });
      });
    });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  customATCButtinInit();
  // Get all elements with the class
  const heroSliders = document.querySelectorAll('.custom-hero-image-slider');
  
  // Initialize Swiper for each slider
  heroSliders.forEach(function(slider, index) {
    new Swiper(slider, {
      loop: true,
      pagination: {
        el: slider.querySelector('.swiper-pagination'), // Find pagination within this specific slider
        clickable: true,
      },
      watchSlidesProgress: true,
      on: {
        init: function() {
          // Custom initialization if needed
          console.log(`Slider ${index + 1} initialized`);
        }
      }
    });
  });



  const customReviewSliders = document.querySelectorAll('.custom-review-slider-main-slider');
  const swiperInstances = [];

  customReviewSliders.forEach(function(slider, index) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 25,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      scrollbar: {
        el: slider.querySelector(".custom-review-slider-main-slider-swiper-scrollbar"),
        hide: false,
        draggable: true,
      },
      breakpoints: {
        320:{
          slidesPerView: 1.2,
          spaceBetween: 25,
          loop: false,
          autoplay:false
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 25,
          loop: false,
          autoplay:false
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 25,
          loop: false,
          autoplay:false
        },
        1024: {
          slidesPerView: 1.5,
          spaceBetween: 25,
          loop: false,
          autoplay:false
        },
        1380: {
          slidesPerView: 2.5,
          spaceBetween: 25
        }
      },
    });
    swiperInstances.push(swiper);
  });


  window.addEventListener('resize', () => {
    swiperInstances.forEach(swiper => {
      swiper.update();
    });
  });




  window.customUGCSliders = document.querySelectorAll('.hw-ugc-slider-main-slider.swiper');
  
  // Initialize Swiper for each slider
  window.customUGCSliders.forEach(function(slider, index) {
    window.customUGCSlider = new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      scrollbar: {
        el: slider.querySelector(".hw-ugc-slider-main-slider-swiper-scrollbar"),
        hide: false,
        draggable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        }
      },
    });
  });
});

// Only define if not already defined (may be defined in old-cart-drawer-custom.js)
function applyShippingThresholdOverridesToElement(el, cartTotal) {
  if (el.hasAttribute('data-free-shipping-unlocked')) {
    el._threshold = 0;
  } else if (window.freeShippingThreshold != null) {
    el._threshold = window.freeShippingThreshold;
    el.setAttribute('threshold', String(window.freeShippingThreshold));
  }

  if (cartTotal != null) {
    el._current = cartTotal;
    el.setAttribute('current', String(cartTotal));
  } else if (el.hasAttribute('current')) {
    const currentAttr = el.getAttribute('current');
    el._current = parseInt(currentAttr, 10);
  }

  if (typeof el.render === 'function') {
    el.render();
  }
}

async function applyShippingThresholdOverrides(options = {}) {
  const bars = document.querySelectorAll('shipping-progress-bar');
  if (!bars.length) return;

  const hasOverride = window.freeShippingThreshold != null;
  if (!hasOverride && !options.force) return;

  let cartTotal = options.cartTotal ?? null;

  if (cartTotal == null && options.fetchCart !== false) {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      if (!response.ok) throw new Error(`cart.js responded with ${response.status}`);
      const cart = await response.json();
      cartTotal = cart.total_price;
    } catch (error) {
      console.warn('[ShippingProgressBar] Failed to fetch cart.js, using existing current value.', error);
    }
  }

  bars.forEach((el) => applyShippingThresholdOverridesToElement(el, cartTotal));
}

(function defineShippingThresholdWindowProperties() {
  let freeShippingThresholdValue;

  Object.defineProperty(window, 'freeShippingThreshold', {
    configurable: true,
    enumerable: true,
    get() {
      return freeShippingThresholdValue;
    },
    set(value) {
      freeShippingThresholdValue = value == null ? undefined : value;
      applyShippingThresholdOverrides();
    },
  });
})();

function initShippingThresholdHooks() {
  document.addEventListener('cart_drawer:updated', (event) => {
    if (window.freeShippingThreshold != null) {
      const cartTotal = event.detail?.cart?.total_price ?? null;
      requestAnimationFrame(() => applyShippingThresholdOverrides({ cartTotal }));
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (window.freeShippingThreshold != null) {
        const cartTotal = event?.cartData?.total_price ?? null;
        requestAnimationFrame(() => applyShippingThresholdOverrides({ cartTotal }));
      }
    });
  }

  if (window.freeShippingThreshold != null) {
    applyShippingThresholdOverrides();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShippingThresholdHooks);
} else {
  initShippingThresholdHooks();
}

if (!customElements.get('shipping-progress-bar')) {
  class ShippingProgressBar extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      
      // Default properties - Tier 1 (Free Shipping)
      this._threshold = 7500; // in cents
      this._current = 0;
      this._currency = '$';
      this._thresholdMessage = 'Add __AMOUNT__ more to get FREE shipping!';
      this._successMessage = 'Congratulations! You qualify for FREE shipping!';
      this._progressColor = '#4CAF50';
      this._backgroundColor = '#f0f0f0';

      // Default properties - Tier 2 (Free Gift)
      this._enableTier2 = false;
      this._tier2Threshold = 15000; // in cents
      this._tier2Message = 'Add __AMOUNT__ more to get a FREE gift!';
      this._tier2SuccessMessage = 'Congratulations! You get a FREE gift!';
      this._tier2ProgressColor = '#d4af37';
    }

  static get observedAttributes() {
    return [
      'threshold', 
      'current', 
      'currency', 
      'threshold-message', 
      'success-message',
      'progress-color',
      'background-color',
      'enable-tier2',
      'tier2-threshold',
      'tier2-message',
      'tier2-success-message',
      'tier2-progress-color',
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    
    switch(name) {
      case 'threshold':
        this._threshold = this.hasAttribute('data-free-shipping-unlocked') ? 0 : parseInt(newValue, 10);
        break;
      case 'current':
        this._current = parseInt(newValue, 10);
        break;
      case 'currency':
        this._currency = newValue;
        break;
      case 'threshold-message':
        this._thresholdMessage = newValue;
        break;
      case 'success-message':
        this._successMessage = newValue;
        break;
      case 'progress-color':
        this._progressColor = newValue;
        break;
      case 'background-color':
        this._backgroundColor = newValue;
        break;
      case 'enable-tier2':
        this._enableTier2 = newValue === 'true';
        break;
      case 'tier2-threshold':
        this._tier2Threshold = parseInt(newValue, 10);
        break;
      case 'tier2-message':
        this._tier2Message = newValue;
        break;
      case 'tier2-success-message':
        this._tier2SuccessMessage = newValue;
        break;
      case 'tier2-progress-color':
        this._tier2ProgressColor = newValue;
        break;
    }
    
    this.render();
  }

  connectedCallback() {
    // Tier 1 attributes
    if (this.hasAttribute('threshold')) {
      this._threshold = parseInt(this.getAttribute('threshold'), 10);
    }
    if (this.hasAttribute('current')) {
      const currentAttr = this.getAttribute('current');
      this._current = parseInt(currentAttr, 10);
    }
    if (this.hasAttribute('currency')) {
      this._currency = this.getAttribute('currency');
    }
    if (this.hasAttribute('threshold-message')) {
      this._thresholdMessage = this.getAttribute('threshold-message');
    }
    if (this.hasAttribute('success-message')) {
      this._successMessage = this.getAttribute('success-message');
    }
    if (this.hasAttribute('progress-color')) {
      this._progressColor = this.getAttribute('progress-color');
    }
    if (this.hasAttribute('background-color')) {
      this._backgroundColor = this.getAttribute('background-color');
    }

    // Tier 2 attributes
    if (this.hasAttribute('enable-tier2')) {
      this._enableTier2 = this.getAttribute('enable-tier2') === 'true';
    }
    if (this.hasAttribute('tier2-threshold')) {
      this._tier2Threshold = parseInt(this.getAttribute('tier2-threshold'), 10);
    }
    if (this.hasAttribute('tier2-message')) {
      this._tier2Message = this.getAttribute('tier2-message');
    }
    if (this.hasAttribute('tier2-success-message')) {
      this._tier2SuccessMessage = this.getAttribute('tier2-success-message');
    }
    if (this.hasAttribute('tier2-progress-color')) {
      this._tier2ProgressColor = this.getAttribute('tier2-progress-color');
    }

    if (this.hasAttribute('threshold') && !this.hasAttribute('data-default-threshold')) {
      this.setAttribute('data-default-threshold', this.getAttribute('threshold'));
    }
    if (this.hasAttribute('tier2-threshold') && !this.hasAttribute('data-default-tier2-threshold')) {
      this.setAttribute('data-default-tier2-threshold', this.getAttribute('tier2-threshold'));
    }

    if (this.hasAttribute('data-free-shipping-unlocked')) {
      this._threshold = 0;
    } else if (window.freeShippingThreshold != null) {
      this._threshold = window.freeShippingThreshold;
      this.setAttribute('threshold', String(window.freeShippingThreshold));
    }

    this.render();
  }

  formatCurrency(cents) {
    return (cents / 100).toFixed(2) + this._currency;
  }

  render() {
    // Determine max threshold for bar calculation
    const maxThreshold = this._enableTier2 ? this._tier2Threshold : this._threshold;

    // Overall progress percentage (based on max threshold)
    const progressPercentage = maxThreshold > 0 ? Math.min(100, (this._current / maxThreshold) * 100) : 100;

    // Tier 1 milestone position on the bar
    const tier1Position = this._enableTier2
      ? (maxThreshold > 0 ? Math.min(100, (this._threshold / maxThreshold) * 100) : 0)
      : 100;

    // Remaining amounts
    const tier1Remaining = Math.max(0, this._threshold - this._current);
    const tier2Remaining = Math.max(0, this._tier2Threshold - this._current);

    // Goals reached
    const tier1Reached = this._current >= this._threshold;
    const tier2Reached = this._enableTier2 && this._current >= this._tier2Threshold;

    // Formatted remaining
    const tier1FormattedAmount = this.formatCurrency(tier1Remaining);
    const tier2FormattedAmount = this.formatCurrency(tier2Remaining);

    // Active tier text
    const activeTier = (tier1Reached && this._enableTier2) ? 'tier2' : 'tier1';
    const currentProgressColor = activeTier === 'tier2' ? this._tier2ProgressColor : this._progressColor;
    const allDone = tier1Reached && (!this._enableTier2 || tier2Reached);

    let displayMessage = '';
    if (activeTier === 'tier1') {
      displayMessage = tier1Reached
        ? this.convertBold(this._successMessage, 'html')
        : this.convertBold(this._thresholdMessage.replace('__AMOUNT__', `<span class="progress-remaining">${tier1FormattedAmount}</span>`));
    } else {
      displayMessage = tier2Reached
        ? this.convertBold(this._tier2SuccessMessage, 'html')
        : this.convertBold(this._tier2Message.replace('__AMOUNT__', `<span class="progress-remaining">${tier2FormattedAmount}</span>`));
    }

    const lockIconUnlocked = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M21,11a2,2,0,0,0-2-2H17V7A5,5,0,0,0,7.669,4.5,1,1,0,0,0,9.4,5.5,3,3,0,0,1,15,7V9H5a2,2,0,0,0-2,2v9a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2Zm-9,6.5a2,2,0,1,1,2-2A2,2,0,0,1,12,17.5Z"/></svg>`;
    const lockIconLocked = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 5H11V3.5C11 2.70435 10.6839 1.94129 10.1213 1.37868C9.55871 0.81607 8.79565 0.5 8 0.5C7.20435 0.5 6.44129 0.81607 5.87868 1.37868C5.31607 1.94129 5 2.70435 5 3.5V5H3C2.73478 5 2.48043 5.10536 2.29289 5.29289C2.10536 5.48043 2 5.73478 2 6V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V6C14 5.73478 13.8946 5.48043 13.7071 5.29289C13.5196 5.10536 13.2652 5 13 5ZM6 3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5C8.53043 1.5 9.03914 1.71071 9.41421 2.08579C9.78929 2.46086 10 2.96957 10 3.5V5H6V3.5Z" fill="black"/></svg>`;
    // Icons from _hover-icons.liquid
    const deliveryIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M255.42,117l-14-35A15.93,15.93,0,0,0,226.58,72H192V64a8,8,0,0,0-8-8H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H49a32,32,0,0,0,62,0h50a32,32,0,0,0,62,0h17a16,16,0,0,0,16-16V120A7.94,7.94,0,0,0,255.42,117ZM192,88h34.58l9.6,24H192ZM32,72H176v64H32ZM80,208a16,16,0,1,1,16-16A16,16,0,0,1,80,208Zm81-24H111a32,32,0,0,0-62,0H32V152H176v12.31A32.11,32.11,0,0,0,161,184Zm31,24a16,16,0,1,1,16-16A16,16,0,0,1,192,208Zm48-24H223a32.06,32.06,0,0,0-31-24V128h48Z"></path></svg>`;
    const giftIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M216,72H180.92c.39-.33.79-.65,1.17-1A29.53,29.53,0,0,0,192,49.57,32.62,32.62,0,0,0,158.44,16,29.53,29.53,0,0,0,137,25.91a54.94,54.94,0,0,0-9,14.48,54.94,54.94,0,0,0-9-14.48A29.53,29.53,0,0,0,97.56,16,32.62,32.62,0,0,0,64,49.57,29.53,29.53,0,0,0,73.91,71c.38.33.78.65,1.17,1H40A16,16,0,0,0,24,88v32a16,16,0,0,0,16,16v64a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V136a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM149,36.51a13.69,13.69,0,0,1,10-4.5h.49A16.62,16.62,0,0,1,176,49.08a13.69,13.69,0,0,1-4.5,10c-9.49,8.4-25.24,11.36-35,12.4C137.7,60.89,141,45.5,149,36.51Zm-64.09.36A16.63,16.63,0,0,1,96.59,32h.49a13.69,13.69,0,0,1,10,4.5c8.39,9.48,11.35,25.2,12.39,34.92-9.72-1-25.44-4-34.92-12.39a13.69,13.69,0,0,1-4.5-10A16.6,16.6,0,0,1,84.87,36.87ZM40,88h80v32H40Zm16,48h64v64H56Zm144,64H136V136h64Zm16-80H136V88h80v32Z"></path></svg>`;

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
        }
        
        .progress-message {
          margin-bottom: 10px;
          text-align: center;
          font-family: "Encode Sans", sans-serif;
          font-size: 12px;
          line-height: 1.3;
          font-weight: 500;
          color: #000;
        }
        .progress-message strong {
          font-size: 12px;
          font-weight: 700;
        }
        span.progress-remaining {
          font-weight: 700 !important;
        }

        .progress-container {
          position: relative;
        }

        .progress-track {
          position: relative;
          height: 5px;
          background-color: ${this._backgroundColor};
          border-radius: 100px;
          ${this._enableTier2 ? 'margin: 0 14px;' : ''}
        }

        .progress-fill {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: ${progressPercentage}%;
          background-color: #1a1a1a;
          border-radius: 100px;
          transition: width 0.4s ease-in-out;
        }

        .milestone {
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          z-index: 2;
          overflow: hidden;
          transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
        }

        .milestone--shipping {
          left: ${tier1Position}%;
          background-color: #000000;
          color: #ffffff;
        }

        .milestone--gift {
          left: 100%;
          background-color: #000000;
          color: #ffffff;
        }

        .milestone--reached {
          box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        }
      </style>
      
      <div class="progress-container">
        <div class="progress-message">
          ${displayMessage}
        </div>
        <div class="progress-track">
          <div class="progress-fill"></div>

          ${this._enableTier2 ? `
          <!-- Tier 1 milestone: delivery icon (only shown in two-tier mode) -->
          <span class="milestone milestone--shipping ${tier1Reached ? 'milestone--reached' : ''}">
            ${deliveryIcon}
          </span>

          <!-- Tier 2 milestone: gift icon -->
          <span class="milestone milestone--gift ${tier2Reached ? 'milestone--reached' : ''}">
            ${giftIcon}
          </span>` : ''}
        </div>
      </div>
    `;
  }

  convertBold(text, format = 'html') {
    const formats = {
      html: (match, content) => `<strong>${content}</strong>`,
      markdown: (match, content) => `**${content}**`,
      css: (match, content) => `<span style="font-weight: bold;">${content}</span>`,
      bbcode: (match, content) => `[b]${content}[/b]`
    };
    const converter = formats[format] || formats.html;
    return text.replace(/\[bold\](.*?)\[\/bold\]/g, converter);
  }
}

  // Register the custom element
  customElements.define('shipping-progress-bar', ShippingProgressBar);
}

window.applyShippingThresholdOverrides = applyShippingThresholdOverrides;

window.clearFreeShippingThreshold = function() {
  document.querySelectorAll('shipping-progress-bar').forEach((el) => {
    const defaultThreshold = el.getAttribute('data-default-threshold');
    if (defaultThreshold != null) {
      el._threshold = parseInt(defaultThreshold, 10);
      el.setAttribute('threshold', defaultThreshold);
      if (typeof el.render === 'function') {
        el.render();
      }
    }
  });
  window.freeShippingThreshold = undefined;
};

// Only define if not already defined (may be defined in old-cart-drawer-custom.js)
if (!customElements.get('cart-drawer-countdown')) {
  class CartDrawerCountdown extends HTMLElement {
    constructor() {
        super();
        
        // Timer state variables
        this.timeRemaining = 0;
        this.timerInterval = null;
        this.timerActive = false;
        this.totalTime = 0;
        
        // Bind methods
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
    }
    
    connectedCallback() {
        this.render();
        this.initialize();
        this.setupEventListeners();
    }
    
    disconnectedCallback() {
        this.cleanup();
    }
    
    render() {
        // Get attributes
        const timeMinutes = parseInt(this.getAttribute('data-time') || '10', 10);
        const countdownText = this.getAttribute('data-text') || 'Time remaining: __COUNTDOWN__';
        
        this.totalTime = timeMinutes * 60; // Convert to seconds
        
        // Create the countdown HTML
        const countdownSpan = '<span class="countdown-main">00:00</span>';
        const finalText = countdownText.replace('__COUNTDOWN__', countdownSpan);
        
        // Set innerHTML
        this.innerHTML = `
            <div class="countdown-wrapper">
                <div class="countdown-text">${finalText}</div>
            </div>
        `;
        
        // Cache DOM elements
        this.wrapper = this.querySelector('.countdown-wrapper');
        this.timerDisplay = this.querySelector('.countdown-main');
    }
    
    setupEventListeners() {
        // Handle page unload
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        
        // Watch for attribute changes
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-count') {
                    this.handleCountChange();
                }
            });
        });
        
        this.observer.observe(this, { attributes: true, attributeFilter: ['data-count'] });
    }
    
    cleanup() {
        // Clear timer
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        
        // Remove event listeners
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        
        // Disconnect observer
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    
    initialize() {
        // Check data-count attribute to determine if countdown should be visible
        const itemCount = parseInt(this.getAttribute('data-count') || '0', 10);
        
        if (itemCount <= 0) {
            // Hide countdown if no items
            this.wrapper.style.display = 'none';
            this.clearTimerStorage();
            return;
        }
        
        // Check if there's a stored timer value in sessionStorage
        const storedTimeStamp = sessionStorage.getItem('cartTimerExpiry');
        
        if (storedTimeStamp) {
            const now = Date.now();
            const expiry = parseInt(storedTimeStamp, 10);
            
            // Calculate how much time has passed since the timer was paused
            if (now < expiry) {
                // Timer was still running, calculate remaining time
                this.timeRemaining = Math.round((expiry - now) / 1000);
            } else {
                // Timer expired since last visit
                this.timeRemaining = 0;
            }
        } else {
            // First time initialization
            this.timeRemaining = this.totalTime;
        }
        
        // If timer is at 0, reset it to full time
        if (this.timeRemaining <= 0) {
            this.timeRemaining = this.totalTime;
        }
        
        // Make countdown visible
        this.wrapper.style.display = '';
        
        // Update display and start timer
        this.updateTimerDisplay();
        this.startTimer();
    }
    
    
    handleCountChange() {
        const itemCount = parseInt(this.getAttribute('data-count') || '0', 10);
        
        if (itemCount <= 0) {
            // Cart is empty, stop timer
            this.stopTimer();
        } else if (!this.timerActive) {
            // Cart has items and timer is not active, start timer
            this.timeRemaining = this.totalTime; // Reset to full time
            this.wrapper.style.display = '';
            this.updateTimerDisplay();
            this.startTimer();
        }
    }
    
    startTimer() {
        if (!this.timerActive) {
            this.timerActive = true;
            
            // Store the expected end time
            const expiryTime = Date.now() + (this.timeRemaining * 1000);
            sessionStorage.setItem('cartTimerExpiry', expiryTime);
            
            this.timerInterval = setInterval(() => {
                this.timeRemaining--;
                this.updateTimerDisplay();
                
                // Update sessionStorage every second
                sessionStorage.setItem('cartTimeRemaining', this.timeRemaining);
                sessionStorage.setItem('cartTimerExpiry', Date.now() + (this.timeRemaining * 1000));
                
                if (this.timeRemaining <= 0) {
                    this.handleTimerComplete();
                }
            }, 1000);
        }
    }
    
    stopTimer() {
        // Clear interval
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        this.timerActive = false;
        
        // Hide the countdown wrapper
        this.wrapper.style.display = 'none';
        
        // Clear the sessionStorage
        this.clearTimerStorage();
    }
    
    updateTimerDisplay() {
        const minutes = Math.floor(this.timeRemaining / 60);
        const seconds = this.timeRemaining % 60;
        
        // Format time as MM:SS
        this.timerDisplay.textContent = 
            `${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')} min`;
    }
    
    handleTimerComplete() {
        // Clear interval
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        this.timerActive = false;
        
        // Hide the countdown wrapper
        this.wrapper.style.display = 'none';
        
        // Clear the sessionStorage
        this.clearTimerStorage();
        setTimeout(() => {
          this.initialize();
        },100);
        
    }
    
    clearTimerStorage() {
        sessionStorage.removeItem('cartTimeRemaining');
        sessionStorage.removeItem('cartTimerExpiry');
    }
    
    handleBeforeUnload() {
        if (this.timerActive) {
            sessionStorage.setItem('cartTimeRemaining', this.timeRemaining);
            sessionStorage.setItem('cartTimerExpiry', Date.now() + (this.timeRemaining * 1000));
        }
    }
}

  // Register the custom element
  customElements.define('cart-drawer-countdown', CartDrawerCountdown);
}
        
class CustomUpsellProduct extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector(".button");
      this.variantSelector = this.querySelector(".cu-product-variant");
      this.thresholdProductId = this.dataset.tpid;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.isOldCart = document.querySelector('#cart-drawer') && !this.cart;
      this.mainId = this.dataset.id;
      this.matchedProducts = [];
    }
    async init(){
    
      const cartRequest = await fetch('/cart.js');
      const cartData = await cartRequest.json();
      this.matchedProducts = cartData.items.filter(item => item.product_id == this.thresholdProductId);

     
    }
    removeAutoUpsell(updates){
       const sections = this.isOldCart ? ["old-cart-drawer", "cart-icon-bubble"] : ["cart-drawer", "cart-icon-bubble"];
       const body = JSON.stringify({
        updates,
        sections: sections,
        sections_url: window.location.pathname,
      });
      fetch('/cart/update.js',{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: body
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (!this.isOldCart && this.cart) {
            CartPerformance.measure("remove:paint-updated-sections", () => {
              this.cart.renderContents(response);
            });
            this.cart.classList.toggle('is-empty', response.item_count === 0);
          } else if (this.isOldCart) {
            // For old cart, trigger refresh event
            window.refreshCart(response);
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });
        return;
    }
    connectedCallback() {
      this.init();
        this.setupEventListeners();
    }
    
    disconnectedCallback() {
    }
    setupEventListeners() {
      this.button.addEventListener("click",this.upsellAddToCart.bind(this));
    }
    async upsellAddToCart(evt){
      
      evt.preventDefault();
      let updates = this.matchedProducts.reduce((acc, { key }) => {
            acc[key] = 0;
            return acc;
        }, {});
     
      const mainId = this.variantSelector.value;
      let items = [
          {
            id:mainId,
            quantity:1,
          }
      ];
      const formData = {
        items:items,
        sections:this.cart.getSectionsToRender().map((section) => section.id),
        sections_url:window.location.pathname
      };
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then((response) => {
          /*if (response.status) {
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
          }
          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: mainId,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });      
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(response);
          });*/
              
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          /*if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          CartPerformance.measureFromEvent("add:user-action", evt);*/
           this.removeAutoUpsell(updates);
        });
    }
    
}

// Register the custom element
customElements.define('custom-upsell-product', CustomUpsellProduct);


 class StockComponent extends HTMLElement {
  constructor() {
      super();
      this.init();
  }

  connectedCallback() {
      this.loadOrGenerateStock();
  }

  init() {
      this.id = this.dataset.id;
      this.min = parseInt(this.dataset.min);
      this.max = parseInt(this.dataset.max);
      this.counter = this.querySelector('.stock-counter');
  }

  loadOrGenerateStock() {
      // Try to get existing value from sessionStorage
      const existingValue = this.getValue();
      
      if (existingValue !== null && existingValue !== '') {
          // Use existing value
          this.updateDisplay(existingValue);
      } else {
          // Generate new random value
          this.generateRandomStock();
      }
  }

  generateRandomStock() {
      const random = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
      
      this.updateDisplay(random);
      this.storeValue(random);
  }

  updateDisplay(value) {
      if (this.counter) {
          this.counter.textContent = value;
      }
  }

  storeValue(value) {
      sessionStorage.setItem(this.id, value);
      console.log(`Stored ${this.id}: ${value}`);
  }

  getValue() {
      return sessionStorage.getItem(this.id)
  }
}

// Define the custom element
customElements.define('stock-component', StockComponent);

class NumberCounter extends HTMLElement {
  constructor() {
      super();
      this.current = 0;
      this.isAnimating = false;
  }

  connectedCallback() {
      this._start = parseInt(this.getAttribute('start')) || 0;
      this._end = parseInt(this.getAttribute('end')) || 100;
      this._duration = parseInt(this.getAttribute('duration')) || 2000;
      this._decimals = parseInt(this.getAttribute('decimals')) || 0;
      this._prefix = this.getAttribute('prefix') || '';
      this._suffix = this.getAttribute('suffix') || '';
      this._separator = this.getAttribute('separator') || '';
      
      this.current = this._start;
      this.textContent = this.formatNumber(this.current);

      // Observamos visibilidad
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // Cuando el elemento esté en el viewport
            if (entry.isIntersecting) {
              this.animate();
              this.observer.disconnect(); // solo 1 vez (opcional)
            }
          });
        },
        { threshold: 0.1 } // 10% visible ya cuenta como "en el viewport"
      );
      this.observer.observe(this);
  }
  
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  formatNumber(num) {
      let rounded = Number(num.toFixed(this._decimals));
      let parts = rounded.toString().split('.');
      
      if (this._separator && parts[0].length > 3) {
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this._separator);
      }
      
      return this._prefix + parts.join('.') + this._suffix;
  }

  animate() {
      if (this.isAnimating) return;
      
      this.isAnimating = true;
      const startTime = Date.now();
      const totalChange = this._end - this._start;
      
      const updateCounter = () => {
          const elapsed = Date.now() - startTime;
          const progress = Math.min(elapsed / this._duration, 1);
          const easedProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
          
          this.current = this._start + (totalChange * easedProgress);
          this.textContent = this.formatNumber(this.current);
          
          if (progress < 1) {
              requestAnimationFrame(updateCounter);
          } else {
              this.isAnimating = false;
          }
      };
      
      requestAnimationFrame(updateCounter);
  }
}

customElements.define('number-counter', NumberCounter);

document.addEventListener('DOMContentLoaded', function() {

  // For all anchor links
  document.querySelectorAll('a[href="#"], a[href="#top"]').forEach(link => {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});
});

function goToReviewSection(){
  const reviewElement = document.querySelector("#judgeme_product_reviews");
  if(reviewElement){
    reviewElement.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start',    // or 'center', 'end', 'nearest'
      inline: 'nearest'  // or 'start', 'center', 'end'
    });
  }
}

subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
  const variantID = evt.data.variant.id;
  const priceElement = document.querySelector(`.custom-variant-price-wrapper[data-vid="${variantID}"]`);
  const submitButtonText = document.querySelector('.custom-button-text-atc span');
  if(priceElement && submitButtonText){
    submitButtonText.innerHTML = priceElement.innerHTML;
  }
});

document.addEventListener('DOMContentLoaded', ()=> {
  const containerNotifications = document.querySelector(`.containerNotifications`);
  //buscar el contador y mostrarlo si no está oculto
  const notificationCount = document.querySelector('.notificationCount');
  if (notificationCount) {
    const isHidden = localStorage.getItem('notificationHidden');
    if (!isHidden || isHidden === 'false' || isHidden === '0') {
      notificationCount.classList.add('visible');
    }
  }

  if(Boolean(containerNotifications)){
    containerNotifications.querySelector(".notificationFormClose").addEventListener("click",(evt)=>{
      containerNotifications.querySelector(".notificationFormClose").closest('.notiDetails').classList.remove("open");
    });
    const openNotificationButton = containerNotifications.querySelector(".openNotification");
    openNotificationButton.addEventListener("click",(evt)=>{
      document.body.classList.remove('firstVisit');
      // añadido: ocultar el contador y guardar en localStorage
      if (notificationCount) {
        notificationCount.classList.remove('visible');
        localStorage.setItem('notificationHidden', '1');
      }
      if(containerNotifications.classList.contains("active")){
        containerNotifications.querySelector(".notificationFormClose").closest('.notiDetails').classList.remove("open");
      }
      containerNotifications.classList.toggle("active");
      evt.preventDefault();
    });

    const openFormNoti = containerNotifications.querySelector("summary");
    openFormNoti.addEventListener("click",(evt)=>{
      openFormNoti.closest('.notiDetails').classList.add("open");
      evt.preventDefault();
    });
    document.addEventListener("click", (evt) => {
      const isClickInside = containerNotifications.contains(evt.target);
      const isButtonClick = openNotificationButton.contains(evt.target);

      if (containerNotifications.classList.contains("active") && !isClickInside && !isButtonClick) {
        containerNotifications.classList.remove("active");
        containerNotifications.querySelector(".notificationFormClose").closest('.notiDetails').classList.remove("open");
      }
    });
  }
});

class hwvideo extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false;
    this.initializeElements();
    this.setupMutationObserver();
  }

  setupMutationObserver() {
    // Watch for changes when variant changes replace the video
    this.observer = new MutationObserver(() => {
      this.initializeElements();
    });

    this.observer.observe(this, {
      childList: true,
      subtree: true
    });
  }

  initializeElements() {
    // Remove old event listeners to prevent duplicates
    if (this.playpause) {
      this.playpause.removeEventListener('click', this.boundPlayPause);
    }
    if (this.muteUnmute) {
      this.muteUnmute.removeEventListener('click', this.boundMuteUnmute);
    }
    if (this.video) {
      this.video.removeEventListener("timeupdate", this.boundUpdateProgressBar);
    }

    // Get fresh references to elements
    this.video = this.querySelector(`video`);
    this.playpause = this.querySelector(`.videoPlayPause`);
    this.muteUnmute = this.querySelector(`.video-mute-unmute`);
    this.progressBar = this.querySelector(`.custom-progress-video__wrapp`);

    // Only add listeners if elements exist
    if (!this.video || !this.playpause || !this.muteUnmute) return;

    // Store bound functions for removal later
    this.boundPlayPause = this.playPauseVideo.bind(this);
    this.boundMuteUnmute = this.muteUnmuteVideo.bind(this);
    this.boundUpdateProgressBar = this.updateProgressBar.bind(this);

    // Add event listeners
    this.playpause.addEventListener('click', this.boundPlayPause);
    this.muteUnmute.addEventListener('click', this.boundMuteUnmute);
    this.video.addEventListener("timeupdate", this.boundUpdateProgressBar);
  }

  connectedCallback() {
    // Wait for window to fully load before auto-playing
    if (!this.isInitialized) {
      if (document.readyState === 'complete') {
        // Window already loaded
        this.autoPlayVideo();
      } else {
        // Wait for window load
        window.addEventListener('load', () => {
          this.autoPlayVideo();
        }, { once: true });
      }
    }
  }

  autoPlayVideo() {
    if (this.video && !this.isInitialized) {
      this.playPauseVideo();
      this.isInitialized = true;
    }
  }

  disconnectedCallback() {
    // Cleanup when element is removed
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  muteUnmuteVideo() {
    if(!this.video) return;
    
    if(this.muteUnmute.classList.contains("active")){
      console.log('The video is unmiuture.111111');

      this.video.setAttribute("muted", "");
      this.video.muted = true;
      this.querySelector(".icon-mute").classList.remove("hidden");
      this.querySelector(".icon-unmute").classList.add("hidden");
      this.muteUnmute.classList.remove("active");
    }else{
      console.log('The video is unmiuture.22222');
      this.video.muted = false;
      this.video.removeAttribute("muted");
      this.muteUnmute.classList.add("active");
      this.querySelector(".icon-mute").classList.add("hidden");
      this.querySelector(".icon-unmute").classList.remove("hidden");
    }
  }

  playPauseVideo() {
    if(!this.video) return;
    
    if (this.video.paused) {
      this.video.play();
      this.playpause.classList.add("active");
      this.querySelector(".icon-play").classList.add("hidden");
      this.querySelector(".icon-pause").classList.remove("hidden");
    } else {
      this.video.pause();
      this.querySelector(".icon-play").classList.remove("hidden");
      this.querySelector(".icon-pause").classList.add("hidden");
      this.playpause.classList.remove("active");
      console.log('The video is playing.');
    }
  }

  updateProgressBar(){
    if(!this.video || !this.progressBar) return;
    
    const percentage = (this.video.currentTime / this.video.duration) * 100;
    this.progressBar.style.width = `${percentage}%`;
  }
}

customElements.define('hw-video', hwvideo);

class CutoffTimeDate extends HTMLElement {
  constructor() {
    super();
    this.hour = parseInt(this.dataset.hour, 10);
    this.min = parseInt(this.dataset.min, 10);
    this.timezone = this.dataset.timezone || "UTC";
    this.updateTimer = this.updateTimer.bind(this);
    this.initTimer();
  }

  initTimer() {
    this.calculateCutoff();
    this.updateTimer();
    this.timerInterval = setInterval(this.updateTimer, 1000);
  }

  calculateCutoff() {
    // Fecha actual en la zona horaria indicada
    const now = new Date(new Date().toLocaleString("en-US", { timeZone: this.timezone }));
    // Hora límite de hoy
    let cutoff = new Date(now);
    cutoff.setHours(this.hour, this.min, 0, 0);
    // Si ya pasó el cutoff → usar mañana
    if (now > cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
    }
    this.secondsLeft = Math.floor((cutoff - now) / 1000);
  }

  formatTime(seconds) {
    let h = Math.floor(seconds / 3600);
    let m = Math.floor((seconds % 3600) / 60);
    if (h < 10) h = `0${h}`;
    if (m < 10) m = `0${m}`;
    return `${h}h${m}`;
  }

  updateTimer() {
    if (this.secondsLeft <= 0) {
      /*this.innerHTML = "Tiempo agotado";
      clearInterval(this.timerInterval);
      return;*/
      this.calculateCutoff();
    }
    this.innerHTML = this.formatTime(this.secondsLeft);
    this.secondsLeft--;
  }
}

customElements.define("cutoff-time-date", CutoffTimeDate);


class CutoffTime extends HTMLElement {
  constructor() {
    super();
    this.totalSeconds = parseInt(this.dataset.time);
    this.updateTimer = this.updateTimer.bind(this);
    this.timerInterval = setInterval(this.updateTimer, 1000);
    this.updateTimer();
  }

  formatTime(seconds) {
    let h = Math.floor(seconds / 3600);
    let m = Math.floor((seconds % 3600) / 60);
    if (h < 10) h = `0${h}`;
    if (m < 10) m = `0${m}`;
    return `${h}h${m}`;
  }

  updateTimer() {
    if (this.totalSeconds <= 0) {
      this.innerHTML = "Discount time ended!";
      clearInterval(this.timerInterval);
      return;
    }
    this.innerHTML = this.formatTime(this.totalSeconds);
    this.totalSeconds--;
  }
}

customElements.define('cutoff-time', CutoffTime);

class CustomCartMainUpsell extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll(".button");
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.isOldCart = document.querySelector('#cart-drawer') && !this.cart;
      this.swiperElement = this.querySelector('.custom-main-upsell-swiper-slider');
      this.mainId = this.dataset.pid;
      
    }
    async init(){
    
      const cartRequest = await fetch('/cart.js');
      const cartData = await cartRequest.json();
      const matchProducts = cartData.items.filter(item => item.product_id == this.mainId);
      const totalQuantity = matchProducts.reduce((sum, item) => sum + (item.quantity || 0), 0);

      if(matchProducts.length > 0 && totalQuantity == cartData.item_count){
        let updates = matchProducts.reduce((acc, { key }) => {
            acc[key] = 0;
            return acc;
        }, {});
        this.removeAutoUpsell(updates);
      }
      if(this.buttons.length > 0){
        this.style.display="block";
      }else{
        this.style.display="none";
      }
      this.loadSwiperSlider();
    }
    removeAutoUpsell(updates){
      
       const sections = this.isOldCart ? ["old-cart-drawer", "cart-icon-bubble"] : ["cart-drawer", "cart-icon-bubble"];
       const body = JSON.stringify({
        updates,
        sections: sections,
        sections_url: window.location.pathname,
      });
      fetch('/cart/update.js',{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: body
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (!this.isOldCart && this.cart) {
            CartPerformance.measure("remove:paint-updated-sections", () => {
              this.cart.renderContents(response);
            });
            this.cart.classList.toggle('is-empty', response.item_count === 0);
          } else if (this.isOldCart) {
            // For old cart, trigger refresh event
            window.refreshCart(response);
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });
    }
    connectedCallback() {
      this.init();
      this.setupEventListeners();
    }
    
    disconnectedCallback() {
    }
    setupEventListeners() {
      //this.buttons.addEventListener("click",this.upsellAddToCart.bind(this));
      this.buttons.forEach((el) => {
        el.addEventListener("click",this.upsellAddToCart.bind(this));
      })
    }
    loadSwiperSlider(){
      this.swiperPrevElement = this.querySelector('.hw-swiper-button-prev');
      this.swiperNextElement = this.querySelector('.hw-swiper-button-next');
      const swiper = new Swiper(this.swiperElement, {
        slidesPerView: 1.5,
        spaceBetween: 10,
        centeredSlides: false,
        navigation: {
          nextEl: this.swiperNextElement,
          prevEl: this.swiperPrevElement,
        }
      });
    }
    upsellAddToCart(evt){
      evt.preventDefault();
      const mainId = evt.target.dataset.vid;
      let items = [
          {
            id:mainId,
            quantity:1,
          }
      ];
      const formData = {
        items:items,
        sections:this.cart.getSectionsToRender().map((section) => section.id),
        sections_url:window.location.pathname
      };
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
          }
          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: mainId,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });      
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(response);
          });
              
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          CartPerformance.measureFromEvent("add:user-action", evt);
        });
    }
    
}

// Register the custom element
customElements.define('custom-cart-main-upsell', CustomCartMainUpsell);
class CartCustomOffetProducts extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.isOldCart = document.querySelector('#cart-drawer') && !this.cart;
      this.swiperElement = this.querySelector('.custom-cart-offert-products-slider');
      this.swiperPrevElement = this.querySelector('.custom-cart-offert-slider-buttons-arrow .custom-prev-arrow');
      this.swiperNextElement = this.querySelector('.custom-cart-offert-slider-buttons-arrow .custom-next-arrow');
     
    }
    
    async init(){
     this.loadSwiperSlider();
     if(window.cartOffertProducts.length > 0){
      this.checkCartOffertProductInCart();
     }
     setTimeout(() => {
      this.autoAddProducts();
     },500);
     
    }
    async autoAddProducts(){
       this.allProductsForms = this.querySelectorAll(`product-form[data-autoadd="true"] form`);
      if(this.allProductsForms.length > 0){
        this.allProductsForms.forEach((el) => {
          el.dispatchEvent(new Event("submit"));
        });
      }
    }
    async checkCartOffertProductInCart(){
      
      const cartRequest = await fetch('/cart.js');
      const cartData = await cartRequest.json();
       const itemsToRemove = [];
       cartData.items.forEach(item => {
        const productId = item.product_id
        
        // Check if this product/variant has a threshold requirement
        const product = window.cartOffertProducts.filter(product => product.id == productId);
        
        if (product.length > 0) {
          const total = cartData.total_price - item.original_line_price; 
          const itemTotal = cartData.total_price;
          
          if (total < product[0].threshold) {
            itemsToRemove.push({
              key: item.key
            });
          }
        }
        
      });
      if (itemsToRemove.length > 0) {
         const stateJson = await this.removeItems(itemsToRemove);
          if (!this.isOldCart && this.cart) {
            CartPerformance.measure("remove:paint-updated-sections", () => {
              this.cart.renderContents(stateJson);
            });
            this.cart.classList.toggle('is-empty', stateJson.item_count === 0);
          } else if (this.isOldCart) {
            // For old cart, trigger refresh event
            window.refreshCart(stateJson);
          }
        }
    }
     async removeItems(itemsToRemove) {
        const updates = {};
        
        // Set quantity to 0 for items to remove
        itemsToRemove.forEach(item => {
          updates[item.key] = 0;
        });

        const sections = this.isOldCart 
          ? ["old-cart-drawer", "cart-icon-bubble"]
          : (this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : ["cart-drawer", "cart-icon-bubble"]);

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            updates,
            sections: sections,
            sections_url:window.location.pathname 
          })
        });

        if (!response.ok) {
          throw new Error('Failed to update cart');
        }

        return await response.json();
      }
    connectedCallback() {
      this.init();
    }
    
    disconnectedCallback() {
      // Destroy swiper instance to prevent memory leaks
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
    
    loadSwiperSlider(){
      this.swiper = new Swiper(this.swiperElement, {
        slidesPerView: 1.3,
        spaceBetween: 10,
        navigation: {
          nextEl: this.swiperNextElement,
          prevEl: this.swiperPrevElement,
        }
      });
    }
}

// Register the custom element
customElements.define('cart-custom-offert-products', CartCustomOffetProducts);

// open tab custom
function open_tab_custom(btn, event){
  console.log('open tab custom');
  const selector = btn.dataset.toggle;
  const block = document.querySelector(`#${selector}`);
  if (btn.classList.contains('active')) {
    block.style.maxHeight = '';
  } else {
    if (btn.classList.contains('main-title')) {
      block.style.maxHeight = '1500px';
    } else {
      block.style.maxHeight = block.scrollHeight + 'px';
    }
    const string_btns = btn.dataset.group;
    let all_btns = document.querySelectorAll(`.title-acordion[data-group="${string_btns}"]`);
    all_btns.forEach(item => {
      let selector_item = item.dataset.toggle;
      if(selector_item != selector) {
        item.classList.remove('active');
      }
    });
  }
  btn.classList.toggle('active');
  //move the viewport if necessary
  setTimeout(() => {    
      if (btn.classList.contains('active')) {
        console.log('contain active class');
        const rect = btn.getBoundingClientRect();
        const completelyVisible = (
          rect.top >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );                
        if (!completelyVisible) {
          btn.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }, 300); // delay = duración de la animación del acordeón
}

function updateImgBig(elem, sectionid){
  if (!elem.classList.contains("is-active")) {
    const biggerImg = document.querySelector(`#featuredimg-${sectionid}`);
    biggerImg.innerHTML = elem.innerHTML;
    let siblings = [...elem.parentNode.children].filter((child) => child !== elem);
    siblings.forEach( sibling =>{sibling.classList.remove("is-active")});
    elem.classList.add("is-active")
  }
}
document.addEventListener("click", function(event) {
    const toggleHeader = event.target.closest(".toggle-header");
    
    if (!toggleHeader) return;
    
    // Toggle visibility of grocery items
    const groceryItems = toggleHeader.nextElementSibling;
    if (groceryItems?.classList.contains("grocery-items")) {
        groceryItems.classList.toggle("hidden");
    }
    
    // Toggle dropdown icon
    const dropdownIcon = toggleHeader.querySelector(".dropdown-icon");
    dropdownIcon?.classList.toggle("open");
    
    // Toggle header text
    const headerTextElement = toggleHeader.querySelector(".header-text");
    if (headerTextElement) {
        const currentText = headerTextElement.textContent;
        
        if (currentText.includes("Afficher")) {
            headerTextElement.textContent = currentText.replace("Afficher", "Masquer");
        } else {
            headerTextElement.textContent = currentText.replace("Masquer", "Afficher");
        }
    }
});

//progress bar custom
class ProgressBarCustom extends HTMLElement {
  constructor() {
    super();
    this.current = 0;
    this.isAnimating = false;
  }

  connectedCallback() {
    this._start = parseInt(this.getAttribute("start")) || 0;
    this._end = Math.min(parseInt(this.getAttribute("end")) || 100, 100);
    this._duration = parseInt(this.getAttribute("duration")) || 2000;

    // Si no hay estructura, la creamos automáticamente
    if (!this.querySelector(".bar-container")) {
      this.innerHTML = `
        <div class="bar-container">
          <div class="bar-fill"></div>
        </div>
      `;
    }

    this.fillEl = this.querySelector(".bar-fill");

    // Observador de visibilidad
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animate();
            this.observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  animate() {
    if (this.isAnimating) return;

    this.isAnimating = true;
    const startTime = Date.now();
    const totalChange = this._end - this._start;

    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / this._duration, 1);
      const easedProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);

      this.current = this._start + (totalChange * easedProgress);

      this.fillEl.style.width = this.current + "%";

      if (progress < 1) {
        requestAnimationFrame(updateProgress);
      } else {
        this.isAnimating = false;
      }
    };

    requestAnimationFrame(updateProgress);
  }
}

customElements.define("progress-bar-custom", ProgressBarCustom);


document.addEventListener("DOMContentLoaded", (event) => {
  // Filter box click handler
document.querySelectorAll(".custom-filter-box").forEach(filterBox => {
  filterBox.addEventListener("click", function() {
    // Remove active class from all filter boxes
    document.querySelectorAll(".custom-filter-box").forEach(box => {
      box.classList.remove("active");
    });
    
    // Add active class to clicked box
    this.classList.add("active");
    
    const t2 = this.dataset.id;
    const e2 = this.classList.contains("first-class");
    
    // Handle filter items
    document.querySelectorAll(".filter-items").forEach(item => {
      if (e2) {
        // Show all items
        item.classList.remove("hide");
        item.style.display = "";
      } else if (item.getAttribute("id") !== t2) {
        // Hide items that don't match
        item.style.display = "none";
        item.classList.add("hide");
      } else {
        // Show matching item
        item.classList.remove("hide");
        item.style.display = "";
      }
    });
  });
});

// Quick add submit handler
document.querySelectorAll(".custom-quick-add__submit").forEach(submitBtn => {
  submitBtn.addEventListener("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Remove active class from all modals
    document.querySelectorAll(".custom-modal__centered.active").forEach(modal => {
      modal.classList.remove("active");
    });
    
    const pid = this.dataset.id;
    const targetModal = document.querySelector(`.custom-modal__centered[data-id="${pid}"]:not(.cart-drawer-bundle-modal)`);
    
    if (targetModal) {
      targetModal.classList.add("active");
    }
    
    document.body.classList.add("remove-zindex");
  });
});

// Modal close handler
document.querySelectorAll("button.custom-modal__close").forEach(closeBtn => {
  closeBtn.addEventListener("click", function() {
    document.querySelectorAll(".custom-modal__centered.active").forEach(modal => {
      modal.classList.remove("active");
    });
    
    document.body.classList.remove("remove-zindex");
  });
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  const openModals = document.querySelectorAll('.custom-modal__centered.active');
  if (!openModals.length) return;
  openModals.forEach((modal) => modal.classList.remove('active'));
  document.body.classList.remove('remove-zindex');
});
});

// replace true reviews judgeme
/*document.addEventListener("DOMContentLoaded", () => {
  let value_text = document.querySelector('.product__info-wrapper .customer-review-block .hide-true-values-judgeme .jdgm-widget .jdgm-prev-badge');
  if (value_text) {
    let num = value_text.getAttribute('data-number-of-reviews');
    if (num) {
      num = num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      let first_block = document.querySelector('.product__info-wrapper .customer-review-block .ccustom-review-block-details .total-rating-block');
      if (first_block) {
        first_block.innerHTML = num;
      }
    }
  }
});*/

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.money_format;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

//form custom
class CustomDefultVariantForm extends HTMLElement {
    constructor() {
        super();
        this.quanityBoxOpeners = this.querySelectorAll(".flavor_add-btn");
        this.quantityButtons = this.querySelectorAll(".flavor_qty-button");
        this.atcButton = this.querySelector(".product-form__submit");
        this.variantInfoOpeners = this.querySelectorAll(".variant-info-opener");
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.isOldCart = document.querySelector('#cart-drawer') && !this.cart;
        this.subsriptionSelectors = this.querySelectorAll(".custom-subscription-wrapper-item label");
        this.productInfo = document.querySelector("product-info");
        this.setupEventListeners();
    }
    setupEventListeners(){
        this.quanityBoxOpeners.forEach((el) => {
            el.addEventListener('click',this.openQuantityBox.bind(this));
        });
        this.quantityButtons.forEach((el) => {
            const that = this;
            el.addEventListener('click',(evt)=>{
                that.onQuantityChange(evt,el);
            });
        });
        this.variantInfoOpeners.forEach((el) => {
            const that = this;
            el.addEventListener('click',(evt)=>{
                that.openVariantInfo(evt,el);
            });
        });
        this.subsriptionSelectors.forEach((el) => {
            const that = this;
            /*el.addEventListener('click',(evt)=>{
                that.onSubscriptionSelection(evt,el);
            });*/
        });
        this.querySelectorAll(".custom-sub-selection").forEach((el) => {
            el.addEventListener("change",(evt) => {
                if(el.value == 'subscribe' && this.querySelector(".custom-subscribe-price-forbutton .atc-s-price")){
                    this.atcButton.querySelector(".atc-s-price").textContent = this.querySelector(".custom-subscribe-price-forbutton .atc-s-price").textContent;
                    if(this.atcButton.querySelector(".atc-o-price")){
                        this.atcButton.querySelector(".atc-o-price").textContent = this.querySelector(".custom-subscribe-price-forbutton .atc-o-price").textContent;
                    }
                    this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.add("hidden");
                  }else{
                    if(this.querySelector(".custom-onetime-price-forbutton .atc-o-price")){
                      this.atcButton.querySelector(".atc-s-price").textContent = this.querySelector(".custom-onetime-price-forbutton .atc-s-price").textContent;
                      if(this.atcButton.querySelector(".atc-o-price")){
                          this.atcButton.querySelector(".atc-o-price").textContent = this.querySelector(".custom-onetime-price-forbutton .atc-o-price").textContent;
                      }

                    }
                    
                    const subscribeElementQuantity = Array.from(this.querySelectorAll(".required-selling .custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
                    if(subscribeElementQuantity > 0){
                      this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.remove("hidden");
                        this.querySelectorAll(".required-selling .custom-bundle-item-qty").forEach((el) => {
                            console.log(el, el.closest('.flavor2_quantity-2').querySelector(`button[data-type="minus"]`),"inside element");
                            el.value = 1;
                            el.closest('.flavor2_quantity-2').querySelector(`button[data-type="minus"]`).dispatchEvent(new Event("click"));
                        });
                    }
                }
                this.updateButtonPrice();
            });
        });
        this.atcButton.addEventListener('click',this.addToCart.bind(this));
    }
    updateButtonPrice(){
         const quantity = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
         if(quantity > 0){
            const selling_plan = this.getSelleingPlanId();
            if(selling_plan != 0){
                const subprice = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.dataset.subscripeprice * el.value), 0);
                const opriceprice = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.dataset.price * el.value), 0);
                if(opriceprice > subprice){
                    this.atcButton.querySelector(".atc-s-price").textContent = Shopify.formatMoney(subprice);
                    if(this.atcButton.querySelector(".atc-o-price")){
                       this.atcButton.querySelector(".atc-o-price").textContent = Shopify.formatMoney(opriceprice);
                    }
                   
                    
                }else{
                    this.atcButton.querySelector(".atc-s-price").textContent = Shopify.formatMoney(opriceprice);
                   
                    if(this.atcButton.querySelector(".atc-o-price")){
                        this.atcButton.querySelector(".atc-o-price").textContent = '';
                    }
                }
                
            }else{
                const cprice = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.dataset.cprice * el.value), 0);
                const opriceprice = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.dataset.price * el.value), 0);
                if(cprice > opriceprice){
                    this.atcButton.querySelector(".atc-s-price").textContent = Shopify.formatMoney(opriceprice);
                    if(this.atcButton.querySelector(".atc-o-price")){
                        this.atcButton.querySelector(".atc-o-price").textContent = Shopify.formatMoney(cprice);
                    }
                    
                    
                }else{
                    this.atcButton.querySelector(".atc-s-price").textContent = Shopify.formatMoney(opriceprice);
                    
                    if(this.atcButton.querySelector(".atc-o-price")){
                        this.atcButton.querySelector(".atc-o-price").textContent = '';
                    }
                }
                
                
            }
            const widget_subprice = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.dataset.subscripeprice * el.value), 0);
            const widget_opriceprice = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.dataset.price * el.value), 0);
            const subPriceEl = this.querySelector(".subscription_sdev .custom-item-rice");
            if (subPriceEl) {
                const priceMain = subPriceEl.querySelector(".custom-item-rice-main") || subPriceEl;
                if (widget_opriceprice > widget_subprice) {
                    priceMain.innerHTML = `<span class="cp-price-strike">${Shopify.formatMoney(widget_opriceprice)}</span> ${Shopify.formatMoney(widget_subprice)}`;
                } else {
                    priceMain.textContent = Shopify.formatMoney(widget_opriceprice);
                }
            }

            const oneTimePriceEl = this.querySelector(".one_time_subscription_sdev .custom-item-rice");
            if (oneTimePriceEl) {
                const priceMain = oneTimePriceEl.querySelector(".custom-item-rice-main") || oneTimePriceEl;
                priceMain.textContent = Shopify.formatMoney(widget_opriceprice);
            }
         }
        
    }
    onSubscriptionSelection(evt,el){
        console.log(el, el.classList.contains("ontime-label"));
        const nosubscribeElementQuantity = Array.from(this.querySelectorAll(".no-selling-required .custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
        const subscribeElementQuantity = Array.from(this.querySelectorAll(".required-selling .custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
        if(el.classList.contains("ontime-label")){
            this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.remove("hidden");
        }else{
            this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.add("hidden");
        }
        
    }
    openVariantInfo(evt,el){
       const parentElement = el.closest(".custom-default-vaariants-item-image-quantity-wrapper");
       const variantID = el.dataset.vid;
       this.querySelectorAll(".custom-variant-info").forEach((el) => {
        if(el.dataset.vid == variantID){
            el.classList.remove("hidden");
        }else{
            el.classList.add("hidden");
        }
       });
       this.querySelectorAll(".custom-default-vaariants-item-image-quantity-wrapper").forEach((el) => {
            if(el == parentElement){
                el.classList.add("selected-info");
            }else{
                el.classList.remove("selected-info");
            }
       });
        const quantity = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
        if(quantity <= 0){
         this.querySelector(".onetime-error-message-wrapper.error-message-wrapper").classList.add("hidden");
        this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.add("hidden");
       }

        /*const productUrl = this.productInfo.dataset.url;

        const idItem = el.closest(".custom-default-variants-item").getAttribute("id");
        const responseHTML = this.productInfo.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, variantID, false),
          targetId: idItem,
          callback: this.productInfo.handleUpdateProductInfo(productUrl),
        });*/
    }

    buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.productInfo.sectionId}`);

        params.push(`variant=${optionValues}`);
       /* if (optionValues.length) {
            params.push(`option_values=${optionValues.join(',')}`);
        }*/

        return `${url}?${params.join('&')}`;
    }

    getSelleingPlanId(){
        const subscribeOption = this.querySelector(".custom-sub-selection:checked");
        if(subscribeOption){
            if(subscribeOption.value == 'subscribe'){
                return this.querySelector(`.custom-selling-plan`).value;
            }
        }
        return 0;
    }
    addToCart(evt){
        evt.preventDefault();
        const quantity = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
        if(quantity > 0){
            let items = [];
            const sellingPlanId = this.getSelleingPlanId();
            this.querySelectorAll(".custom-bundle-item-qty").forEach((el) => {
                const el_quantity = Number(el.value);
                if(el_quantity > 0){
                    if(sellingPlanId != 0){
                        items.push({
                            id:el.dataset.id,
                            quantity:el_quantity,
                            selling_plan:sellingPlanId
                        });
                    }else{
                        items.push({
                            id:el.dataset.id,
                            quantity:el_quantity
                        });
                    }
                    
                }
            });
            if(items.length > 0){

                const first_id = items[0].id;
                if(window.productNVOffered ==  true && window.offeredNVProducts.length > 0 ){
                  items.push({
                    id:window.offeredNVProducts[0],
                    quantity:1,
                    parent_id: parseInt(first_id),
                    properties: {
                      _parent_variant_id: first_id,
                    },
                  })
                }
                
                this.atcButton.classList.add('loading');
                this.atcButton.querySelector('.loading__spinner').classList.remove('hidden');
                const sections = this.isOldCart 
                  ? ["old-cart-drawer", "cart-icon-bubble"]
                  : (this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : ["cart-drawer", "cart-icon-bubble"]);
                const formData = {
                    items:items,
                    sections: sections,
                    sections_url:window.location.pathname
                };
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    return response.json();
                })
                .then((response) => {
                    if (response.status) {
                        if (!this.cart && !this.isOldCart) {
                            window.location = window.routes.cart_url;
                            return;
                        }
                    }
                    
                    if (this.isOldCart) {
                        // For old cart, trigger refresh and open
                        window.refreshCart(response);
                        document.dispatchEvent(new CustomEvent('cart:open'));
                    } else {
                        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: first_id,
                            cartData: response,
                        }).then(() => {
                            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                        });
                        const quickAddModal = this.atcButton.closest('quick-add-modal');
                        if (quickAddModal) {
                            document.body.addEventListener(
                                'modalClosed',
                                () => {
                                    setTimeout(() => {
                                        CartPerformance.measure("add:paint-updated-sections", () => {
                                            this.cart.renderContents(response);
                                        });
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            CartPerformance.measure("add:paint-updated-sections", () => {
                                this.cart.renderContents(response);
                            });
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                  this.resetAllTheData();
                    this.atcButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    this.atcButton.removeAttribute('aria-disabled');
                    this.atcButton.querySelector('.loading__spinner').classList.add('hidden');
                    CartPerformance.measureFromEvent("add:user-action", evt);
                });
            }
        }
    }
    resetAllTheData(){
      this.querySelectorAll(".custom-bundle-item-qty").forEach((el) => {
         const quanity = Number(el.value);
        if(quanity >= 1){
          const parentElement = el.closest(".flavor2_quantity-container");
          el.value = 1;
          parentElement.querySelector(`.flavor_qty-button[data-type="minus"]`).click();
        }
      });
    }
    onQuantityChange(evt,button){
        const buttonType = button.dataset.type;
        const inputElement = button.parentElement.querySelector('.custom-bundle-item-qty');
        const quantityDisplayElement = button.parentElement.querySelector('.flavor_qty-display');
        if(buttonType == 'plus'){
          inputElement.stepUp();
        }else{
          inputElement.stepDown();
          if(inputElement.value <= 0){
            button.parentElement.classList.add("hidden");
            button.parentElement.previousElementSibling.classList.remove("hidden");
          }
        }
        quantityDisplayElement.textContent = inputElement.value;
        this.updateButtonState();
    }
    updateButtonState(){
        const quantity = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
        if(this.atcButton && quantity > 0){
            this.atcButton.disabled = false;
            this.atcButton.querySelector(".custom-text-without-selection").classList.add("hide");
            this.atcButton.querySelector(".default-text").classList.remove("hide");
        }else{
            if(this.atcButton){
                this.atcButton.disabled = true;
                this.atcButton.querySelector(".custom-text-without-selection").classList.remove("hide");
                this.atcButton.querySelector(".default-text").classList.add("hide");
            }
        }
        this.querySelectorAll(".custom-default-vaariants-item-image-quantity-wrapper").forEach((el) =>{
            const quantity = Number(el.querySelector(".custom-bundle-item-qty").value);
            if(quantity > 0){
                el.classList.add("active");
            }else{
                el.classList.remove("active");
            }
        });
        
        const nosubscribeElementQuantity = Array.from(this.querySelectorAll(".no-selling-required .custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
        /*if(nosubscribeElementQuantity > 0){
            this.querySelector(`.custom-sub-selection[value="subscribe"]`).disabled = true;
        }else{
            this.querySelector(`.custom-sub-selection[value="subscribe"]`).disabled = false;
        }*/
        const subscribeElementQuantity = Array.from(this.querySelectorAll(".required-selling .custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
        /*if(subscribeElementQuantity > 0){
            this.querySelector(`.custom-sub-selection[value="onetime"]`).disabled = true;
        }else{
            this.querySelector(`.custom-sub-selection[value="onetime"]`).disabled = false;
        }*/
        /*if(nosubscribeElementQuantity > 0 && subscribeElementQuantity > 0){
            if(this.atcButton){
                this.atcButton.disabled = true;
                this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.remove("hidden");
            }
        }else{
            this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.add("hidden");
        }*/
       if( this.querySelector(".one_time_subscription_sdev")){
        this.querySelector(".one_time_subscription_sdev").classList.remove("gray-disabled-bg");
        if(subscribeElementQuantity > 0){
          this.querySelector(".one_time_subscription_sdev").classList.add("gray-disabled-bg");
        }
       }
       
       this.updateButtonPrice();
       
    }

    openQuantityBox(evt){
        const button = evt.target;
        const parentElement = button.closest(".no-selling-required");
        const parentElementsubscribe = button.closest(".required-selling");
        this.querySelector(".onetime-error-message-wrapper.error-message-wrapper").classList.add("hidden");
        this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.add("hidden");
        const selling_plan = this.getSelleingPlanId();

        const nosubscribeElementQuantity = Array.from(this.querySelectorAll(".no-selling-required .custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
        const subscribeElementQuantity = Array.from(this.querySelectorAll(".required-selling .custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
       
        if(parentElement && selling_plan != 0 && subscribeElementQuantity > 0 ){
            this.querySelector(".onetime-error-message-wrapper.error-message-wrapper").classList.remove("hidden");
        }
         
       if(selling_plan == 0 && nosubscribeElementQuantity > 0 && subscribeElementQuantity > 0 ){
            this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.remove("hidden");
            return false;
        }
         if(parentElementsubscribe && selling_plan == 0 ){
          this.querySelector(`.custom-sub-selection[value="subscribe"]`).checked = true;
          this.querySelector(`.custom-sub-selection[value="subscribe"]`).dispatchEvent(new Event("change"));
         }
        if(parentElementsubscribe && selling_plan == 0 && nosubscribeElementQuantity > 0 ){
            this.querySelector(".subscribe-error-message-wrapper.error-message-wrapper").classList.remove("hidden");
            
        }
        button.classList.add("hidden");
        button.parentElement.querySelector(".flavor2_quantity-container").classList.remove("hidden");
        button.parentElement.querySelector(`.flavor2_quantity-container .flavor_qty-button[data-type="plus"]`).click();
    }

    connectedCallback() {
    }
    disconnectedCallback() {
    }
    
}

// Register the custom element
customElements.define('custom-default-with-variant-form', CustomDefultVariantForm);




// Get the 'active' parameter from the URL
function getActiveParam() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('active');
}

// Function to open the tab based on the parameter
function openTabFromURL() {
    const activeTab = getActiveParam();
    
    if (activeTab && activeTab == 'tous') {
      console.log("ddddd", activeTab);
        // Find and click the tab with matching value
      if(document.querySelector("#step-filter-default")){
         document.querySelector("#step-filter-default").checked = true
        document.querySelector("#step-filter-default").dispatchEvent(new Event("change"));
      }
     
    }
}

// Run when DOM is ready
window.addEventListener('load', openTabFromURL);

function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

// Function to create and show toast
function showToast() {
    
    // Create toast element
    const toast = document.createElement('div');
    toast.className = `toast-custom`;
    
    toast.innerHTML = `
        <span class="toast-icon"><svg class="icon icon-success" viewBox="0 0 13 13"><path fill="#428445" stroke="#fff" stroke-width=".7" d="M6.5 12.35a5.85 5.85 0 1 0 0-11.7 5.85 5.85 0 0 0 0 11.7Z"></path><path stroke="#fff" d="m5.533 8.664 3.72-3.982M4.106 6.769l2.032 1.857"></path></svg></span>
        <div class="toast-content">
            <div class="toast-message">Merci de ton inscription</div>
        </div>
    `;

    // Add to body
    document.body.appendChild(toast);

    // Trigger animation
    setTimeout(() => toast.classList.add('show'), 10);

    // Auto remove after duration
    setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => toast.remove(), 300);
    }, 5000);
}

// Check for toast parameter on page load
window.addEventListener('DOMContentLoaded', () => {
    const customer_posted = getURLParameter('customer_posted');
    if (customer_posted === 'true' ) {
        showToast();
    }
});